<div class="chart-overview">
  <apx-chart id="chart"
    *ngIf="chartOptions"
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [markers]="chartOptions.markers"
    [stroke]="chartOptions.stroke"
    [yaxis]="chartOptions.yaxis"
    [dataLabels]="chartOptions.dataLabels"
    [title]="chartOptions.title"
    [fill]="chartOptions.fill"
    [tooltip]="chartOptions.tooltip"
    [legend]="chartOptions.legend"
    [colors]="chartOptions.colors"
    [plotOptions]="chartOptions.plotOptions"
    [labels]="chartOptions.labels"
    class="d-block">
  </apx-chart>
</div>